var TorsoNestedModel = require('backbone-torso/modules/NestedModel');
var insuranceEstimationExtService = require('./../urls').insuranceEstimationExtService;

/**
 * Safely convert amount to a negative number even if it is a string.
 * @param amount {String|Number} to negate.
 * @return {Number} the negative of amount or 0.
 */
function safeNegative(amount) {
  amount = amount || 0;
  amount = parseFloat(amount);

  return -amount;
}

/**
 * Model for Estimation data, which includes a list of appointments
 *
 * @class EstimationModel
 * @extends Torso.Model
 * @constructor
 */
module.exports = TorsoNestedModel.extend({
  idAttribute: 'accountNumber',
  /**
   * @method url
   * @returns {String} the url for the insurance estimation resource.
   * @override
   */
  url: insuranceEstimationExtService,

  /**
   * Retrieve the the negative of the insurance adjustments for this estimate.
   * @method getNegativeInsuranceAdjustment
   * @returns {Number} the negative of the insurance adjustments.
   */
  getNegativeInsuranceAdjustment: function() {
    var insuranceAdjustments = this.get('insuranceEstimation.insuranceAdjustment');

    return safeNegative(insuranceAdjustments);
  },

  /**
   * Retrieve the the negative of the insurance payments for this estimate.
   * @method getNegativeInsurancePayment
   * @returns {Number} the negative of the insurance payments.
   */
  getNegativeInsurancePayment: function() {
    var insuranceAdjustments = this.get('insuranceEstimation.insurancePayment');

    return safeNegative(insuranceAdjustments);
  },

  /**
   * Returns true if patient has paid estimate
   * @method insuranceEstimateIsPaid
   * @returns {boolean}
   */
  insuranceEstimateIsPaid: function() {
    var remainingBalance = this.get('remainingBalance');
    return remainingBalance <= 0;
  },

  /**
   * Returns the identifier for this estimation model in the format of id-{accountNumber}.
   * @method getIdentifier
   * @returns {string}
   */
  getIdentifier: function() {
    return 'id-' + this.get('accountNumber');
  }
});
